import { useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Check } from "lucide-react";

export const NewsletterSignup = ({ source = "footer", onSuccess }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("loading");
    try {
      await api.subscribeNewsletter(email.trim(), source);
      setState("done");
      onSuccess && onSuccess();
    } catch {
      setState("idle");
    }
  };

  if (state === "done")
    return (
      <div className="flex items-center gap-2 text-emerald-400 text-sm font-medium" data-testid={`newsletter-done-${source}`}>
        <Check className="w-4 h-4" /> Tack! Du är anmäld.
      </div>
    );

  return (
    <form onSubmit={submit} className="flex gap-2" data-testid={`newsletter-form-${source}`}>
      <input
        type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="din@mejl.se" aria-label="E-postadress"
        className="flex-1 min-w-0 rounded-lg bg-black/40 border border-white/15 px-3 py-2.5 text-sm text-white placeholder:text-white/30 focus:border-amber-500 focus:outline-none"
        data-testid={`newsletter-email-${source}`}
      />
      <button type="submit" disabled={state === "loading"} data-testid={`newsletter-submit-${source}`}
        className="shrink-0 rounded-lg bg-amber-500 px-4 py-2.5 text-sm font-bold uppercase tracking-wide text-black hover:bg-amber-400 transition-colors">
        {state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : "Anmäl"}
      </button>
    </form>
  );
};
